import { getTelemetryClientConfig } from '@ms/yammer-telemetry-store';
import type { AADApplication, TelemetryClientId } from '@ms/yammer-telemetry-support';

const telemetryClientIdToAADApplication: Record<TelemetryClientId, AADApplication | undefined> = {
  UNKNOWN: undefined,
  YAMMER_EMBED: 'YammerEmbed',
  YAMMER_METAOS_OUTLOOK_PERSONAL_APP: 'YammerMetaOsOutlookPersonalApp',
  YAMMER_METAOS_OFFICE_PERSONAL_APP: 'YammerMetaOsOfficePersonalApp',
  YAMMER_OUTLOOK: 'YammerOutlook',
  YAMMER_SHAREPOINT: 'YammerSharePoint',
  YAMMER_SHAREPOINT_SHARETO: 'YammerSharePointShareTo',
  YAMMER_SHAREPOINT_SPNEWS: 'YammerSharePointSPNews',
  YAMMER_TEAMS: 'YammerTeams',
  YAMMER_TEAMS_MEETING: 'YammerTeamsMeeting',
  YAMMER_TEAMS_PERSONAL_APP: 'YammerTeamsPersonalApp',
  YAMMER_TEAMS_BRANDED_EXPERIENCES_APP: 'YammerTeamsBrandedExperiencesApp',
  YAMMER_VIVA_CONNECTIONS: 'YammerVivaConnections',
  YAMMER_VIVAENGAGE_PERSONAL_APP: 'YammerTeamsPersonalApp',
  YAMMER_VIVAENGAGE_OUTLOOK_PERSONAL_APP: 'YammerMetaOsOutlookPersonalApp',
  YAMMER_VIVAENGAGE_OFFICE_PERSONAL_APP: 'YammerMetaOsOfficePersonalApp',
  YAMMER_WEB: 'YammerWeb',
};

type GetApplication = () => AADApplication;
export const getAADApplication: GetApplication = () => {
  const clientConfig = getTelemetryClientConfig();
  if (!clientConfig) {
    return 'YammerWeb';
  }

  const application = telemetryClientIdToAADApplication[clientConfig.telemetryClientId];
  if (!application) {
    throw new Error(`Unsupported application type: '${clientConfig.telemetryClientId}'`);
  }

  return application;
};
